import { Box } from "@mui/material";
import info from "Assets/Icons/info.svg";
import close from "Assets/Icons/close.svg";

export default function RoutingInfoModal({ handleCloseModal, title, body }) {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        zIndex: 3,
        bottom: 45,
        left: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: { xs: "318px", md: "90%" },
          borderRadius: "var(--spacing-md)",
          background: "var(--color-surface-alerts-status-info-tint, #CCEDF9)",
          boxShadow:
            "0 8px 16px -16px rgba(41, 45, 50, 0.24), 0 32px 80px 0 rgba(41, 45, 50, 0.12)",
          fontFamily: "var(--body-font-family)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            padding: "var(--spacing-md)",
            justifyContent: "flex-start",
          }}
        >
          <Box>
            <img
              className="top-menu-icon"
              alt="Info"
              src={info}
              width={23}
              height={23}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            padding: "var(--spacing-md)",
            flexDirection: "row",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "var(--spacing-xs)",
            }}
          >
            <Box
              sx={{
                color: "var(--color-text-primary)",
                fontSize: "var(--body-size)",
                fontWeight: 700,
              }}
            >
              {title}
            </Box>
            <Box
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                color: "var(--color-text-secondary)",
              }}
            >
              {body}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <Box
              sx={{ padding: "var(--spacing-xs)" }}
              onClick={handleCloseModal}
            >
              <img
                className="close-icon"
                alt="Close"
                src={close}
                width={24}
                height={24}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
